import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

import { AtxLoadPipe } from '../../other/pipes/load';
import { AtxLimitPipe } from '../../other/pipes/limit';
import { AtxPopConfirmModule } from '../../feedback/pop-confirm';
import { AtxTablePaginationComponent, AtxTableComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        NgxPaginationModule,
        AtxPopConfirmModule,
    ],
    declarations: [
        AtxLoadPipe,
        AtxLimitPipe,
        AtxTableComponent,
        AtxTablePaginationComponent,
    ],
    exports: [
        AtxTableComponent,
    ],
})

export class AtxTableModule {}
